module.exports = (
  Api,
  $uibModalInstance,
  $scope,
  source,
  countries,
  canRemove
) ->
  $scope.canRemove = canRemove
  $scope.isNew     = !canRemove

  $scope.ok = () ->
    $uibModalInstance.close({ action: 'Save', curatedSource: $scope.curatedSource })

  $scope.remove = () ->
    $uibModalInstance.close({ action: 'Remove', curatedSource: $scope.curatedSource })

  $scope.cancel = () ->
    $uibModalInstance.dismiss()

  $scope.queryEngine = ($select) ->
    Api.Engine.get({name: $select.search, deleted: false }).$promise.then (engines) ->
      $scope.engines = engines.results

  $scope.engines = []
  $scope.forms = {}
  $scope.countries = countries
  $scope.curatedSource = source
